import { Tag } from '@surveycake/rc';
import { useLatestCallback, useOnKeyDownEnter } from '@surveycake/rhooks';
import { PageService } from 'app/core/page';
import { Exception, ExceptionService } from 'app/core/status';
import { useSurveyConfig } from 'app/core/survey-config';
import { Button } from 'app/shared/components';
import React, {
  ChangeEventHandler,
  useCallback,
  useRef,
  useState
} from 'react';
import { useStyles } from './styles';

export default function Form() {
  const surveyConfig = useSurveyConfig();
  const { wording } = surveyConfig;
  const setPage = PageService.useSetPage();
  const setException = ExceptionService.useSetException();
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState(false);
  const [pending, setPending] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const submit = useLatestCallback(async () => {
    setPending(true);
    try {
      await surveyConfig.initialPrivateData(password);
      surveyConfig.handleStageFinished(setPage, setException, {
        thirdPartyLogin: true
      });
      surveyConfig.logSelf();
    } catch (error) {
      if (error instanceof Exception) {
        setException(error);
      } else {
        /**
         * password incorrect.
         */
        setPending(false);
        setPasswordError(true);
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }
    }
  });
  const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    event => {
      setPassword(event.target.value);
      setPasswordError(false);
    },
    [setPassword, setPasswordError]
  );
  const onKeyDown = useOnKeyDownEnter(submit);
  const styles = useStyles();

  return (
    <>
      {passwordError && (
        <Tag color="error">{wording.common.exception.private.error}</Tag>
      )}
      <div className={styles.passwordForm}>
        <input
          ref={inputRef}
          className={styles.passwordInput}
          value={password}
          type="password"
          disabled={pending}
          onChange={!pending ? onChange : undefined}
          onKeyDown={!pending ? onKeyDown : undefined}
        />
        <Button
          color="primary"
          loading={pending}
          onClick={!pending ? submit : undefined}
        >
          {wording.common.exception.private.confirm}
        </Button>
      </div>
    </>
  );
}
